<div
  style="{style}"
  class="selezione apertura-{apertura}"
  class:piana={piana}
  class:errore={errore}
  class:disabilitata={disabilitata}
  class:con-etichetta={etichetta != null}
  role="combobox"
  aria-controls="select"
  aria-expanded="{opzioni_visualizzate}"
  tabindex="0"
  on:click={visualizza_opzioni}
  on:keydown={event => {
    if (event.key === "Escape") {
      opzioni_visualizzate = false
    }
    focus_prima_opzione(event)
  }}
>
  <slot/>

  {#if etichetta != null}
    <label for="">{etichetta}</label>
  {/if}

  <div
    class="contenitore-valore"
    class:messo-a-fuoco={opzioni_visualizzate}
    bind:this={elemento_valore}
  >
    <div
      class="valore-selezionato"
      class:segnaposto={valore == null}
    >
      {#if remota && in_caricamento && valore != null}
        <Caricatore piccolo={true}/>
      {:else if valore != null && opzione_selezionata != null}
        <slot name="valore" {opzione_selezionata}>
          {opzione_selezionata.testo}
        </slot>
      {:else if segnaposto != null}
        {segnaposto}
      {:else}
        {t.seleziona_un_valore[$l]}
      {/if}
    </div>

    {#if cancellabile && valore != null && valore !== ""}
      <div class="contenitore-cancellazione">
        <Bottone
          style="border-radius:0; height:40px; width:40px"
          piccolo={true}
          variante="piano"
          disabilitato={disabilitata}
          on:click={cancella_valore}
        >
          <Icona tipo="chiudi"/>
        </Bottone>
      </div>
    {/if}
    <div class="contenitore-icona">
      <Icona bind:tipo={icona}/>
    </div>
  </div>

  {#if opzioni_visualizzate}
    <div class="tendina-opzioni">
      {#if ricercabile}
        <div
            class="ricerca"
            bind:this={elemento_ricerca}>
          <Inserimento
              style="margin-bottom:0"
              piano={true}
              tipo="testuale"
              icona="ricerca"
              metti_a_fuoco={true}
              attributi={attributi}
              disabilitato={disabilitata}
              segnaposto={segnaposto_ricerca != null ? segnaposto_ricerca : t.cerca_fra_le_opzioni[$l]}
              bind:valore={testo_ricerca}
              on:input
              on:keydown={event =>{
                if (event.key === "ArrowDown") {
                  opzioni_elements[0].focus()
                }
              }}/>
        </div>
      {:else if ricercabile_senza_icona}
        <div
          class="ricerca"
          bind:this={elemento_ricerca}
        >
          <Inserimento
              style="margin-bottom:0"
              piano={true}
              tipo="testuale"
              metti_a_fuoco={true}
              attributi={attributi}
              disabilitato={disabilitata}
              segnaposto={segnaposto_ricerca != null ? segnaposto_ricerca : t.cerca_fra_le_opzioni[$l]}
              bind:valore={testo_ricerca}
              on:input
              on:keydown={focus_prima_opzione}/>
        </div>
      {/if}
      <div
        class="contenitore-opzioni"
        transition:fade={{ duration: 150 }}
        role="listbox"
        use:onDestroyOpzioniAction
      >
        {#if in_caricamento}
          <Caricatore piccolo={true}/>
        {:else if opzioni_ricercate.length > 0}
          {#each opzioni_ricercate as opzione, indice}
            <div
              class="opzione"
              class:disabilitata={opzione.disabilitata}
              bind:this={opzioni_elements[indice]}
              role="option"
              aria-selected="{opzione_selezionata && opzione_selezionata.valore === opzione.valore}"
              tabindex="-1"
              on:click|preventDefault={evento => imposta_valore(opzione)}
              on:keydown|preventDefault={event => {
                event.stopPropagation()
                if (event.key === "ArrowUp" && opzioni_ricercate[indice - 1]) {
                  opzioni_elements[indice - 1].focus()
                } else if (event.key === "ArrowDown" && opzioni_ricercate[indice + 1]) {
                  opzioni_elements[indice + 1].focus()
                } else if (event.key === "Enter"){
                  imposta_valore(opzione)
                }
              }}
            >
              <slot name="opzione" {opzione}>
                {opzione.testo}
              </slot>
            </div>
          {/each}
        {:else}
          <div class="segnaposto">
            {t.nessuna_opzione_disponibile[$l]}
          </div>
        {/if}
      </div>
    </div>
  {/if}

  {#if errore != null}
    <div class="errore">
      {errore}
    </div>
  {/if}

  <slot name="azioni"/>
</div>

<svelte:window on:click={determina_se_pressione_esterna}/>

<style>
  div.selezione {
    position:       relative;
    margin-bottom:  14px;
    cursor:         pointer;
  }

  /* Etichetta */
  div.selezione > label {
    display:        flex;
    color:          var(--colore-testo-leggero);
    font-weight:      400;
    line-height:      30px;
    font-size:        12px;
    margin-bottom:    0px;
    margin-left:      0px;
    cursor:         default;
  }
  div.selezione.piana > label {
    padding-left:   7px;
  }

  /* Valore selezionato */
  div.selezione > div.contenitore-valore {
    display:        flex;
    align-items:    center;
    width:          100%;
    height:         var(--height-valore, 42px);
    background:     var(--colore-bianco);
    color:          var(--colore-testo);
    border:         1px solid var(--colore-bordo);
    font-family:    "Inter", sans-serif;
    font-weight:    400;
    font-size:      var(--font-size-valore, 14px);
    line-height:    24px;
    padding:        9px 12px;
    margin:         0;
    white-space:    nowrap;
    transition:     border-color 0.3s ease-in-out;
    border-radius:  var(--border-radius-valore, 5px);
    position:       relative;
  }
  div.selezione.disabilitata > div.contenitore-valore {
    border:           none;
    background-color: var(--colore-disabilitato);
    cursor:           not-allowed;
  }
  div.selezione > div.contenitore-valore.messo-a-fuoco {
    border:         1px solid var(--colore-primario);
  }
  div.selezione > div.contenitore-valore > div.valore-selezionato {
    width:          100%;
    overflow:       hidden;
    text-overflow:  ellipsis;
    margin-right:   15px;
  }
  div.selezione > div.contenitore-valore > div.valore-selezionato.segnaposto {
    color:          var(--colore-segnaposto);
    font-style:     italic;
  }
  div.selezione.piana > div.contenitore-valore {
    border:         1px solid transparent;
    background:     inherit;
  }
  div.selezione.piana > div.contenitore-valore.messo-a-fuoco {
    border:         1px solid transparent;
  }
  div.selezione > div.contenitore-valore div.contenitore-icona {
    transform:      rotate(0deg);
    transition:     transform .3s ease-in-out;
  }
  div.selezione > div.contenitore-valore.messo-a-fuoco div.contenitore-icona {
    transform:      rotate(180deg);
  }

  /* Icona */
  div.selezione > div.contenitore-valore > div.contenitore-icona,
  div.selezione > div.contenitore-valore > div.contenitore-cancellazione {
    display:          flex;
    justify-content:  center;
    align-items:      center;
    width:            33px;
    height:           42px;
  }

  /* Opzioni */
  div.tendina-opzioni {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background:       var(--colore-bianco);
    border-left:      1px solid var(--colore-bordo);
    border-right:     1px solid var(--colore-bordo);
    border-bottom:    1px solid var(--colore-bordo);
    max-height:       355px;
    z-index:          8;
  }
  div.contenitore-opzioni {
    overflow:         auto;
    max-height:       300px;
  }
  div.selezione.apertura-sopra div.contenitore-opzioni {
    bottom:           100%;
  }
  div.selezione.piana div.contenitore-opzioni {
    border-top:       1px solid var(--colore-bordo);
  }
  div.selezione div.contenitore-opzioni > div.segnaposto,
  div.selezione div.contenitore-opzioni > div.opzione {
    height:           42px;
    line-height:      42px;
    overflow:         hidden;
    text-overflow:    ellipsis;
    white-space:      nowrap;
    padding:          0 7px;
  }
  div.selezione div.contenitore-opzioni > div.opzione {
    cursor:           pointer;
  }
  div.selezione div.contenitore-opzioni > div.segnaposto {
    color:            var(--colore-segnaposto);
    font-style:       italic;
  }
  div.selezione > div.tendina-opzioni > div.contenitore-opzioni > div.opzione:focus {
    border:           1px solid var(--colore-primario);
    border-radius: 0;
  }
  div.selezione > div.tendina-opzioni > div.contenitore-opzioni > div.opzione:hover,
  div.selezione > div.tendina-opzioni > div.contenitore-opzioni > div.opzione:focus {
    background:       var(--colore-sorvolo);
  }
  div.selezione div.contenitore-opzioni > div.opzione.disabilitata {
    cursor:           not-allowed;
    color:            var(--colore-segnaposto);
  }
  div.selezione div.contenitore-opzioni > div.opzione.disabilitata:hover {
    background:       var(--colore-bianco);
  }

  /* Ricerca su opzioni */
  div.selezione > div.tendina-opzioni > div.ricerca {
    background-color: var(--colore-bianco);
    border:    1px solid var(--colore-bordo);
  }

  /* Errore. */
  div.selezione.errore > div.contenitore-valore {
    border-color:     var(--colore-rosso);
  }
  div.selezione.errore > div.errore {
    margin-left:      1.75px;
    color:            var(--colore-rosso);
    font-size:        12px;
  }
</style>

<script>
  import Icona from "@/base/componenti/Icona.svelte"
  import Bottone from "@/base/componenti/Bottone.svelte"
  import Caricatore from "@/base/componenti/Caricatore.svelte"
  import Inserimento from "@/base/componenti/Inserimento.svelte"
  import { localizzazione as l } from "@/base/sorgenti/svuby"
  import { fade } from "svelte/transition"
  import { createEventDispatcher } from "svelte"

  export let valore = null
  export let errore = null
  export let opzioni = []
  export let etichetta = null
  export let disabilitata = false
  export let remota = false
  export let in_caricamento = false
  export let cancellabile = false
  export let ricercabile = false
  export let ricercabile_senza_icona = false
  export let piana = false
  export let apertura = "sotto"
  export let icona = "espandi"
  export let attributi = {}
  export let segnaposto = null
  export let segnaposto_ricerca = null
  export let style = ""

  const t = {
    seleziona_un_valore: {
      it: `Seleziona un valore`,
      en: `Please select`,
      de: `Bitte auswählen`
    },
    nessuna_opzione_disponibile: {
      it: `Nessuna opzione disponibile`,
      en: `No available options`,
      de: `Keine verfügbaren Optionen`
    },
    cerca_fra_le_opzioni: {
      it: `Cerca fra le opzioni`,
      en: `Search in options`,
      de: `Suchen Sie in Optionen`
    } }

  let propaga = createEventDispatcher()
  let elemento_valore = null
  let elemento_ricerca = null
  let opzione_selezionata = null
  let opzioni_visualizzate = false
  let opzioni_ricercate = opzioni
  let testo_ricerca = ""
  let opzioni_elements = []

  // Converte le opzioni in oggetto testo/valore.
  opzioni = opzioni.map(opzione => {
    if (Object.keys(opzione).include("valore")) return opzione
    return { testo: opzione, valore: opzione }
  })

  ////
  // Visualizza le opzioni.
  function visualizza_opzioni() {
    if (disabilitata) return
    if (remota) return propaga("open")
    opzioni_visualizzate = true
  }

  ////
  // Imposta il valore.
  function imposta_valore(opzione) {
    if (opzione.disabilitata) return
    valore = opzione.valore
  }

  ///
  // Cancella il valore.
  function cancella_valore() {
    valore = null
    opzione_selezionata = null
    propaga("change", { valore: valore })
  }

  ////
  // Seleziona l'opzione.
  function seleziona_opzione() {
    if (valore == null) return opzione_selezionata = null
    if (opzione_selezionata && opzione_selezionata.valore == valore) return

    opzione_selezionata = opzioni.find(opzione => opzione.valore == valore)
    opzioni_visualizzate = false
    if (!remota) testo_ricerca = ""
    propaga("change", { valore: valore, opzione_selezionata })
  }

  ////
  // Ricerca fra le opzioni.
  function ricerca_fra_opzioni() {
    opzioni_elements = []
    if (remota) return opzioni_ricercate = opzioni

    opzioni_ricercate = opzioni.filter((opzione) => {
      if (testo_ricerca == null || testo_ricerca == "") return true
      if (opzione.testo == null) return false
      return opzione.testo.match(new RegExp(`.*${testo_ricerca}.*`, "i")) != null
    })

    return opzioni_ricercate
  }

  ////
  // Determina se è stata fatta una pressione su un'area
  // esterna alla selezione. Se è così, nascondi le opzioni.
  function determina_se_pressione_esterna(evento) {
    if (disabilitata) return
    if (evento == null || evento.target == null) return

    let pressione_su_valore, pressione_su_ricerca
    if (elemento_valore != null) pressione_su_valore = elemento_valore.contains(evento.target)
    if (elemento_ricerca != null) pressione_su_ricerca = elemento_ricerca.contains(evento.target)

    opzioni_visualizzate = pressione_su_valore || pressione_su_ricerca
  }

  /**
   * Gestisce la pressione del tasto ArrowDown sul campo di ricerca o sul contenitore principale.
   * Se viene premuto ArrowDown, previene il comportamento di default e sposta il focus
   * sulla prima opzione disponibile nella lista delle opzioni.
   *
   * @param {KeyboardEvent} event - L'evento keydown da gestire.
   */
  function focus_prima_opzione(event) {
    if (event.key === "ArrowDown") {
      event.preventDefault()
      opzioni_elements[0].focus()
    }
  }

  /**
   * Svelte action che esegue una funzione di cleanup quando il nodo associato viene rimosso dal DOM.
   * In questo caso, quando il contenitore delle opzioni viene distrutto, svuota l'array opzioni_elements
   * per evitare riferimenti obsoleti agli elementi DOM delle opzioni.
   *
   * @param {HTMLElement} node - Il nodo DOM a cui è applicata l'action.
   * @returns {Object} Oggetto con il metodo destroy chiamato automaticamente da Svelte.
   */
  function onDestroyOpzioniAction(node) {
    return {
      destroy() {
        opzioni_elements = [];
      }
    };
  }

  // Quando cambia il valore, seleziona l'opzione.
  $: { valore; seleziona_opzione() }
  // Quando cambiano le opzioni, seleziona l'opzione.
  $: { opzioni; seleziona_opzione() }

  // Ricerca fra le opzioni.
  $: if (testo_ricerca != null && opzioni.length > 0) ricerca_fra_opzioni()

  // Reimposta le opzioni se remota.
  $: if (remota && opzioni != null) ricerca_fra_opzioni()
</script>
